import React from 'react';
import { Link } from 'react-router-dom';
import './BookCard.css';
import noBookCover from '../assets/no-book-cover.png'; // Import local placeholder image

function BookCard({ book }) {
  return (
    <div className="book-card">
      <Link to={`/books/${book._id}`} className="book-link">
        <img
          src={book.imageUrl || noBookCover}
          alt={book.bookName}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noBookCover;
          }}
        />
        <p className="bookcard-title">{book.bookName}</p>
        <p className="bookcard-author">By {book.author}</p>
        <div className="bookcard-category">
          {book.categories && book.categories.length > 0 ? (
            book.categories.map((category, index) => (
              <p key={index}>{typeof category === 'object' ? category.categoryName : category}</p>
            ))
          ) : (
            <p>Uncategorized</p>
          )}
        </div>
        <div className="bookcard-status">
          <p className={`status ${book.bookStatus ? book.bookStatus.toLowerCase() : 'unavailable'}`}>
            {book.bookStatus || "Unavailable"}
          </p>
        </div>
      </Link>
    </div>
  );
}

export default BookCard; 